import { render, staticRenderFns } from "./BasicDetail.vue?vue&type=template&id=8463995a&scoped=true&"
import script from "./BasicDetail.vue?vue&type=script&lang=js&"
export * from "./BasicDetail.vue?vue&type=script&lang=js&"
import style0 from "./BasicDetail.vue?vue&type=style&index=0&id=8463995a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8463995a",
  null
  
)

export default component.exports